export default function OpcSetupInstructions() {
  return (
    <div className="text-xs space-y-2">
      <p className="font-semibold m-0">
        The next step is to login to Oracle Primavera Cloud.
      </p>
      <p className="font-semibold m-0">
        Before proceeding, ensure that the Oracle Primavera Cloud (OPC) user
        authorizing this integration is configured with the following:
      </p>

      <ol className="list-decimal pl-4 m-0 space-y-2">
        <li>
          <span className="font-semibold">Integration User Setup:</span> Ensure
          the user account is configured as per{" "}
          <a
            href="https://docs.oracle.com/en/industries/construction-engineering/primavera-cloud/rest-api/D254388.html"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium workflow-document-upload"
          >
            Oracle Guidelines
          </a>
          {"."}
        </li>
        <li>
          <span className="font-semibold">Enable API Access:</span> In OPC,
          navigate to{" "}
          <span className="font-semibold">
            Global Admin → Privacy &amp; Security → Security
          </span>{" "}
          and enable API access for this user (
          <a
            href="https://docs.oracle.com/en/industries/construction-engineering/primavera-cloud/rest-api/D207871.html"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium workflow-document-upload"
          >
            Details
          </a>
          {")."}
        </li>
        <li>
          <span className="font-semibold">Assign Permissions:</span> The user
          must be a member of the required project(s) with these workspace
          permissions:
          <ul className="list-[lower-alpha] pl-4 m-0 mt-1 space-y-0.5">
            <li>
              <span className="font-semibold">Project Baselines:</span> Access
              enabled.
            </li>
            <li>
              <span className="font-semibold">File Permissions:</span>{" "}
              &quot;Download files&quot; enabled.
            </li>
            <li>
              <span className="font-semibold">Integration:</span>{" "}
              &quot;Export&quot; and &quot;Poll Export Job Status&quot; enabled.
            </li>
          </ul>
        </li>
      </ol>
    </div>
  );
}
